export default {
  about: "نبذة عنّا",
  courses: "الدورات",
  pricing: "التسعير",
  blog: "مدونة",
  contact: "اتصل بنا",
};
